import { _ } from '../model/ccc'

export const ICON_RADIO_OFF = `<svg fill="currentColor" class="${_.ccc_icon}" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/></svg>`
